<template>
<!--  <div class="counsel">-->
<!--    <div class="lyan reveal-inftop">-->
<!--      <div class="commen">-->
<!--        <h6>给印工社留言，免费获取更多服务</h6>-->
<!--        <div class="lyana">-->
<!--          <input-->
<!--            class="input1 fl"-->
<!--            v-model="form.companyName"-->
<!--            type="text"-->
<!--            placeholder="请输入您的公司名称"-->
<!--          />-->
<!--          <input-->
<!--            class="input1 fl"-->
<!--            v-model="form.phone"-->
<!--            type="text"-->
<!--            placeholder="请输入联系方式"-->
<!--          />-->
<!--          <textarea-->
<!--            class="fl"-->
<!--            v-model="form.content"-->
<!--            placeholder="请输入需求"-->
<!--          ></textarea>-->
<!--          <input-->
<!--            class="input2 fl"-->
<!--            type="submit"-->
<!--            value="提交留言"-->
<!--            @click="submit"-->
<!--          />-->
<!--          <div class="clearfix"></div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
export default {
  // name: "counsel",
  data() {
    return {
      form: {
        companyName: '',
        phone: '',
        content: '',
        name: '',
      },
    };
  },
  methods: {
    // 重置留言
    reset() {
      this.form = {
        companyName: '',
        phone: '',
        content: '',
        name: '',
      };
    },
    // 提交留言
    submit() {
      const url = `${process.env.API_HOST}/portal/add`;
      this.$axios({
        method: 'post',
        url,
        data: this.form,
        contentType: 'application/json',
      })
        .then((res) => {
          this.reset();
          this.$message({
            showClose: true,
            message: '提交成功',
            type: 'success',
            duration: 2000,
          });
        })
        .catch((mgs) => {
          this.$message({
            showClose: true,
            message: '网络繁忙，稍后再试',
            type: 'error',
            duration: 2000,
          });
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/counsel.vue